export const numberEndsWithPlus = (value: string) =>
  value.endsWith('+') && !Number.isNaN(Number.parseInt(value.substring(0), 10));
